import { useTheme } from '@/components/ThemeProvider'

const BasicLayout = ({ children }) => {
  const { resolvedTheme } = useTheme()

  return (
    <div className='bg-background min-h-screen w-full'>
      <Choose>
        <When condition={resolvedTheme === 'dark'}>
          <div className='absolute top-0 left-0 w-full p-5'>
            <img className='h-12 w-auto' src='/logo.svg' alt='Mindjoy logo' />
          </div>
        </When>
        <Otherwise>
          <div className='absolute top-0 left-0 w-full p-5'>
            <img className='h-12 w-auto' src='/mindjoy-logo.svg' alt='Mindjoy logo' />
          </div>
        </Otherwise>
      </Choose>

      <div className='min-h-screen flex flex-col items-center md:justify-center overflow-hidden p-5 pt-24 md:p-5'>
        <div className='w-full md:max-w-md md:mt-15'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default BasicLayout
